module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"benefits":"Benefits","cta":{"buttonText":"Call now","header":"Need a hand?","subHeader":"Our experts are waiting to help"},"features":"About the policy","summary":"Summary","terms":"Terms"}}')
  delete Component.options._Ctor
}
